import { MdDelete, MdEdit } from "react-icons/md";
import { formatPrettyAddress } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";

const PropertyCard = ({
  id,
  image,
  title,
  location,
  price,
  timeAgo,
  onEdit,
  onDelete,
}) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/admin/properties/details/${id}`)}
      className="bg-white cursor-pointer font-poppins rounded-lg shadow-sm hover:shadow-lg transition-all overflow-hidden group"
    >
      <div className="relative overflow-hidden aspect-[5/4] will-change-transform">
        <img
          src={image}
          alt={title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
        />

        {/* Hover Actions */}
        <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(id);
            }}
            className="bg-white/70 backdrop-blur-sm p-2 rounded-lg shadow-md hover:bg-blue-50 hover:scale-110 transition-all"
          >
            <MdEdit className="w-4 h-4 text-blue-600" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.(id);
            }}
            className="bg-white/70 backdrop-blur-sm p-2 rounded-lg shadow-md hover:bg-red-50 hover:scale-110 transition-all"
          >
            <MdDelete className="w-4 h-4 text-red-600" />
          </button>
        </div>
      </div>

      <div className="p-3 flex flex-col gap-y-2">
        <h3 className="font-medium text-[#031722] text-xs line-clamp-1">
          {title}
        </h3>
        <p className="text-[10px] text-text-secondary line-clamp-1">
          {formatPrettyAddress(location)}
        </p>

        <div className="flex justify-between items-center">
          <span className="text-[#031722] font-medium text-xs">{price}</span>
          <span className="text-[10px] text-text-muted">{timeAgo}</span>
        </div>
      </div>
    </div>
  );
};
export default PropertyCard;
